import { useContext } from 'react';
import { EMPTY_OBJECT, AppContext, UserContext } from 'commons-ui';

import useService from '../utils/useService';
import { ADD_CONFIG_ENDPOINT, CLONE_CONFIG_ENDPOINT, DETAILS_CONFIG_ENDPOINT, EDIT_CONFIG_ENDPOINT } from '../../gstHelper';

export const makeActionHandler = (action: any, params: any) => {
	const { history, rowData = EMPTY_OBJECT, setConfirmationDialog } = params;
	const { app, showAlert } = useContext(AppContext);
	const { user } = useContext(UserContext);
	const { toggleIsDisabledField } = useService();
	switch (action.id) {
		case 'edit':
			return () => {
				history.push({
					pathname: EDIT_CONFIG_ENDPOINT,
					state: {
						rowData
					}
				});
			};
		case 'clone':
			return () => {
				const filteredRowData = {
					segmentList: action.segmentList,
					expList: action.expList,
					bucketList: action.bucketList,
					gstOfferSegmentsData: action.gstOfferSegmentsData
				};
				history.push({
					pathname: CLONE_CONFIG_ENDPOINT,
					state: { ...{ rowData }, ...filteredRowData }
				});
			};
		case 'add':
			return () => {
				const filteredRowData = {
					segmentList: action.segmentList,
					expList: action.expList,
					bucketList: action.bucketList,
					gstOfferSegmentsData: action.gstOfferSegmentsData
				};
				history.push({
					pathname: ADD_CONFIG_ENDPOINT,
					state: filteredRowData
				});
			};
		case 'back':
			return () => {
				history.push({
					pathname: DETAILS_CONFIG_ENDPOINT
				});
			};
		case 'remove': {
			const toggleIsDisabled = () => {
				return toggleIsDisabledField(rowData, history, user, app, showAlert);
			};
			return () => {
				setConfirmationDialog({
					show: true,
					header: 'Remove from app?',
					handleAlertConfirmation: toggleIsDisabled
				});
			};
		}
		default:
			return () => {};
	}
};

export default {
	makeActionHandler
};
